import { render, staticRenderFns } from "./veStuYystu.vue?vue&type=template&id=5d3f245a&scoped=true"
import script from "./veStuYystu.vue?vue&type=script&lang=js"
export * from "./veStuYystu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f245a",
  null
  
)

export default component.exports